module.exports = __webpack_public_path__ + "static/media/eliminar.c0f4229e.png";